module.exports = __webpack_public_path__ + "static/media/take-challenge-popup-header.25ade01a.png";